import { render, staticRenderFns } from "./EmotionWheel.vue?vue&type=template&id=534bfff2&scoped=true"
import script from "./EmotionWheel.vue?vue&type=script&lang=js"
export * from "./EmotionWheel.vue?vue&type=script&lang=js"
import style0 from "./EmotionWheel.vue?vue&type=style&index=0&id=534bfff2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534bfff2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('534bfff2')) {
      api.createRecord('534bfff2', component.options)
    } else {
      api.reload('534bfff2', component.options)
    }
    module.hot.accept("./EmotionWheel.vue?vue&type=template&id=534bfff2&scoped=true", function () {
      api.rerender('534bfff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Visualisations/EmotionWheel.vue"
export default component.exports